<script lang="ts" setup>
  const { orderingAppNavTo } = useOrderingAppNavigation()

  const props = defineProps<{
    restaurantId: string | number
  }>()

  function handleNavigation() {
    orderingAppNavTo(`/home&restaurant=${props.restaurantId}`)
  }
</script>

<template>
  <div class="c-order-now-banner">
    <span class="header-4">Hungry?</span>
    <CButton dark-mode variant="primary" @click="handleNavigation" @keydown.enter="handleNavigation">Order now</CButton>
  </div>
</template>

<style lang="scss" scoped>
  .c-order-now-banner {
    display: flex;

    align-items: center;
    justify-content: center;
    gap: 32px;

    width: 100%;
    padding: 24px 16px;

    background-color: var(--color-base-red);

    span {
      color: var(--color-base-white);
    }
  }
</style>
